/** Registers the ProgressBar parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseProgressBar } from './parser';
const progressBarRegistration = {
    typeName: 'ProgressBar',
    parser: parseProgressBar,
};
nodeRegistry.register(progressBarRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map